import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import { ProPlayers } from "@/game-lol/models/lol-pro-players.mjs";

export function getProPlayers(options = {}) {
  return getData(
    `${appURLs.CDN_PLAIN}/league/pro_players.json`,
    ProPlayers,
    ["lol", "proBuildPros"],
    options,
  );
}
